// Copyright 2005-2014 Jim Radford <radford@blackbean.org>, David Caldwell <david@porkrind.org>

var solitaire = {};
var game;
function start(title, ui, seed) {
    var variants = {}
    for (var t in solitaire) {
        variants[t] = { title: t, game: solitaire[t] }
        for (let [name, variant] of Object.entries(solitaire[t].variants ?? solitaire[t].prototype?.variants ?? {}))
                variants[name] = { title: variant.alias || name, game: solitaire[t] }
    }

    var the_game = new variants[title].game(variants[title].title, ui);
    the_game.new_game(seed);
    window.piwik_vars.push(['setCustomVariable', 4, "Card Size", the_game.ui.cardset.size]);
    require('./gotd').start = function(game_of_the_day) { the_game.new_game(game_of_the_day) };
    return the_game;
}

module.exports = {
    games: solitaire,
    start: start
};
// Copyright 2005-2014 Jim Radford <radford@blackbean.org>, David Caldwell <david@porkrind.org>

var solitaire = {};
var game;
function start(title, ui, seed) {
    var variants = {}
    for (var t in solitaire) {
        variants[t] = { title: t, game: solitaire[t] }
        for (let [name, variant] of Object.entries(solitaire[t].variants ?? solitaire[t].prototype?.variants ?? {}))
                variants[name] = { title: variant.alias || name, game: solitaire[t] }
    }

    var the_game = new variants[title].game(variants[title].title, ui);
    the_game.new_game(seed);
    window.piwik_vars.push(['setCustomVariable', 4, "Card Size", the_game.ui.cardset.size]);
    require('./gotd').start = function(game_of_the_day) { the_game.new_game(game_of_the_day) };
    return the_game;
}

module.exports = {
    games: solitaire,
    start: start
};
